export const safeFields = new Set(['cursor', 'clarityCursor', 'tokenBalances', 'stakingInfo']);
